import AuthenticationInterface from '@/utilities/auth/interfaces/AuthenticationInterface'

class Authentication implements AuthenticationInterface {
  refreshToken: string = ''
  token: string = ''
  VueJwtDecode: any

  constructor(data: any, VueJwtDecode: any) {
    const { token, refresh } = data
    this.token = token
    this.refreshToken = refresh
    this.VueJwtDecode = VueJwtDecode
  }

  azureLogin(commit: any, cookies: any): void {
    // eslint-disable-next-line camelcase
    const { name, preferred_username, exp } = this.VueJwtDecode.decode(this.token)
    const expire = new Date(exp * 1000).toISOString()

    cookies.set('user', name, expire, null, null, null, 'Lax')
    cookies.set('email', preferred_username, expire, null, null, null, 'Lax')

    commit('SET_TOKEN', this.token)
    commit('SET_USER', name)
    commit('auth_success', { token: this.token, name, exp })
  }

  getToken(): string {
    return this.token
  }

  isToken(): boolean {
    return !!this.token
  }

  getAuthorization(): string {
    return `Bearer ${this.token}`
  }

  getRefreshToken(): string {
    return this.refreshToken
  }

  refreshTokenPeriod(): number {
    return 5 * 60 * 60 * 1000
  }

  isExpired(): boolean {
    const { exp } = this.VueJwtDecode.decode(this.token)
    const current = Math.floor(new Date().getTime() / 1000)
    return exp <= current
  }

  getEmail(): string {
    // eslint-disable-next-line camelcase
    const { preferred_username, unique_name } = this.VueJwtDecode.decode(this.token)
    // eslint-disable-next-line camelcase
    return preferred_username ?? unique_name
  }
}

export default Authentication
